/**
 * RUG Report styling constants
 * These constants define the visual styling for the RUG report PDF generation
 */

// Color constants
export const REPORT_COLORS = {
  GECKO_BLUE_GREEN: '#2e5266',
  GECKO_GREEN: '#4a7c59',
  GECKO_BRIGHT_GREEN: '#32af8e',
  GECKO_GRAY: '#4d4d4d',
  LIGHT_GRAY: '#999999',
  DARK_GRAY: '#666666',
  DARKER_GRAY: '#333333',
  BORDER_GRAY: '#e0e0e0',
  BLACK: '#000000',
  WHITE: '#ffffff',
} as const

// Typography constants
export const TYPOGRAPHY = {
  FONT_FAMILY: 'Helvetica',

  // Font sizes
  FONT_SIZE: {
    EXTRA_SMALL: 6,
    SMALL: 8,
    MEDIUM: 10,
    LARGE: 12,
    EXTRA_LARGE: 14,
    TITLE: 20,
  },

  // Font weights
  FONT_WEIGHT: {
    NORMAL: 'normal' as const,
    BOLD: 'bold' as const,
    EXTRA_BOLD: 800,
  },

  // Line heights
  LINE_HEIGHT: {
    TIGHT: 1,
    NORMAL: 1.2,
  },
} as const

// Spacing constants
export const SPACING = {
  // Padding
  PADDING: {
    EXTRA_SMALL: 3,
    SMALL: 8,
    MEDIUM: 15,
    LARGE: 20,
    EXTRA_LARGE: 30,
    PAGE_BOTTOM: 40,
  },

  // Margins
  MARGIN: {
    TINY: 2,
    EXTRA_SMALL: 4,
    SMALL: 5,
    MEDIUM: 8,
    LARGE: 10,
    EXTRA_LARGE: 18,
    HUGE: 20,
  },

  // Gaps
  GAP: {
    EXTRA_SMALL: 4,
    SMALL: 8,
    MEDIUM: 16,
  },
} as const

// Layout constants
export const LAYOUT = {
  // Heights
  HEIGHT: {
    DIVIDER_LINE: 2,
    DATA_ITEM_MIN: 12,
    PAGE_HEADER: 40,
  },

  // Widths
  WIDTH: {
    FULL: '100%',
    DECORATIVE_LARGE: 32,
    DECORATIVE_MEDIUM: 20,
    DECORATIVE_SMALL: 16,
    DECORATIVE_EXTRA_SMALL: 8,
  },

  // Positions
  POSITION: {
    FOOTER_BOTTOM: 30,
    FOOTER_TEXT_BOTTOM: 15,
    FOOTER_SIDE_OFFSET: 110,
  },

  // Border widths
  BORDER_WIDTH: {
    THIN: '1px',
    MEDIUM: '2px',
  },

  // Flex values
  FLEX: {
    NARROW: 1,
    MEDIUM: 1.2,
    WIDE: 1.5,
    DOUBLE: 2,
    TRIPLE_HALF: 3.5,
  },
} as const

// Measurement formatting constants
export const MEASUREMENT_FORMAT = {
  DIMENSION_FRACTION_DIGITS: {
    MIN: 2,
    MAX: 2,
  },
  NOMINAL_RANGE_FRACTION_DIGITS: {
    MIN: 3,
    MAX: 3,
  },
} as const

// Mathematical constants
export const MATH_CONSTANTS = {
  RADIUS_TO_DIAMETER_SCALE: 2,
  PERCENTAGE_SCALE: 100,
  FIXED_DECIMAL_PLACES: 2,
} as const

// Default text values
export const DEFAULT_VALUES = {
  X_AXIS_START_LOCATION: '(Pos. dir.) Vertical weld left of north manway',
  Y_AXIS_START_LOCATION: '(Pos. dir. upward) bottom of shell course one',
  AXIS_REFERENCE_PREFIX: '0" Reference:',
} as const
